// src/config/api.js

const isProd = process.env.NODE_ENV === 'production';
export const API_BASE_URL = isProd ? '/api' : (process.env.REACT_APP_API_URL || 'http://localhost:3001/api');

/**
 * Base fetch client configuration
 */
export const fetchClient = async (endpoint, options = {}) => {
  const url = `${API_BASE_URL}${endpoint}`;
  
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {})
  };

  const config = {
    ...options,
    headers
  };

  const response = await fetch(url, config);
  
  if (!response.ok) {
    let errorData;
    try {
      errorData = await response.json();
    } catch (e) {
      errorData = { error: 'Ocurrió un error en la red' };
    }
    const error = new Error(errorData.error || 'API Error');
    error.status = response.status;
    error.data = errorData;
    throw error;
  }
  
  return response;
};
